import React from "react";
import CollectionsListingPage from "~/src/components/collection/pages/CollectionsListingPage";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

export default function Collections() {
  return (
    <NavbarLayout pb={0}>
      <CollectionsListingPage />
    </NavbarLayout>
  );
}
